import ContentPullQuote from './ContentPullQuote'

export default ContentPullQuote
